import { useEffect } from 'react';
import { LOGOUT_URL } from '../../constants';
import { clearLocalStorageExceptDMS } from '../../util/clearLocalStorage';

export default function LogoutCallback(): null {

    useEffect(() => {
        (async () => {
            const baseLogoutUrl = `${LOGOUT_URL}?source=unify`;
            try {
                const idToken = JSON.parse(localStorage.getItem('okta-token-storage') ?? '{}').idToken?.idToken;
                clearLocalStorageExceptDMS();
                sessionStorage.clear();
                if (idToken) {
                    window.location.assign(`${baseLogoutUrl}&id_token_hint=${encodeURIComponent(idToken)}`);
                } else {
                    window.location.assign(baseLogoutUrl);
                }
            } catch (err) {
                console.error('Error during logout callback processing:', err);
                clearLocalStorageExceptDMS();
                window.location.assign(`${baseLogoutUrl}`);
            }
        })();
    }, []);

    return null;
}
